import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["signatureInput", "initialsInput", "signature", "initials"]

  connect() {
    this.update()
  }

  update() {
    this.signatureTargets.forEach((preview) => {
      preview.textContent = this.signatureInputTarget.value
    })
    this.initialsTargets.forEach((preview) => {
      preview.textContent = this.initialsInputTarget.value
    })
  }
}
